import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addBeatOutlet, addOutlet, addOutletAddress, addOutletMapping, addOutletOrgData, addOutletOrgNote, getAddressType, getBeatOutletById, getBeatOutletList, getBeatOutletStatus, getCityStateByTownId, getOutletAddressById, getOutletAddressList, getOutletById, getOutletCategoryTypes, getOutletDCRSummary, getOutletList, getOutletMappingById, getOutletMappingList, getOutletMaritalStatus, getOutletOrganizationDataById, getOutletOrganizationList, getOutletOrgNoteById, getOutletOrgNotesList, getOutletParent, getOutletQualificationList, getOutletRCPASummary, getOutletSalutation, getOutletSgpiOutSummary, getOutletStatus, getOutletStockList, getOutletVisitFrequency, getTownFilter, updateBeatOutlet, updateOutlet, updateOutletAddress, updateOutletMapping, updateOutletOrgData, updateOutletOrgNote, updateOutletStock } from "./CustomerRepository";
import { getOutletType } from "../../../FSM/Subscriber/hooks/SubscriberRepository";
import { showToast } from "../../../../utils/toastUtils";

  export const useOutletList = ({
    enabled,
    params = {},
  }: {
    enabled: boolean;
    params?: Record<string, any>;
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_LIST", params],
      queryFn: () => getOutletList(params),
      enabled,
      retry: false,
    });
  };

    export const useOutletType = ({
    enabled,
  }: {
    enabled: boolean;
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_TYPE"],
      queryFn: getOutletType,
      enabled,
      retry: false,
    });
  };

   export const useOutletSalutation = ({
    enabled,
  }: {
    enabled: boolean;
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_SALUTATION"],
      queryFn: () => getOutletSalutation(),
      enabled,
      retry: false,
    });
  };

     export const useOutletMaritalStatus = ({
    enabled,
  }: {
    enabled: boolean;
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_MARITAL_STATUS"],
      queryFn: () => getOutletMaritalStatus(),
      enabled,
      retry: false,
    });
  };

   export const useOutletStatus = ({
    enabled,
  }: {
    enabled: boolean;
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_STATUS"],
      queryFn: () => getOutletStatus(),
      enabled,
      retry: false,
    });
  };

  export const useOutletById = ({
    enabled,
    outletId
  }: {
    enabled: boolean;
    outletId:any
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_BY_ID",outletId],
      queryFn: () => getOutletById(outletId),
      enabled,
      retry: false,
    });
  };

  export const useUpdateOutlet =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>updateOutlet(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet:", error.message)
    }
      
   })
} 

 export const useAddOutlet =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addOutlet(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet:", error.message)
    }
      
   })
}

export const useAllTowns = ({
    enabled,
    params = {},
  }: {
    enabled: boolean;
    params?: Record<string, any>;
  }) => {
    return useQuery({
      queryKey: ["GET_ALL_TOWNS", params],
      queryFn: () => getTownFilter(params),
      enabled,
      retry: false,
    });

  };

  export const useAddressType = ({
    enabled,
  }: {
    enabled: boolean;

  }) => {
    return useQuery({
      queryKey: ["GET_ADDRESS_TYPE"],
      queryFn: () => getAddressType(),
      enabled,
      retry: false,
    });
  };

  export const useCityStateByTown = ({
    enabled,
    params,
  }: {
    enabled: boolean;
    params:Record<string,any>;

  }) => {
    return useQuery({
      queryKey: ["GET_CITY_STATE_BY_TOWN",params],
      queryFn: () => getCityStateByTownId(params),
      enabled,
      retry: false,
    });
  };

  export const useOutletAddressById = ({
    enabled,
    params,
  }: {
    enabled: boolean;
    params:Record<string,any>;

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ADDRESS_BY_ID",params],
      queryFn: () => getOutletAddressById(params),
      enabled,
      retry: false,
    });
  };

  export const useOutletOrganizationList = ({
    enabled,
    outletId,
    params
  }: {
    enabled: boolean;
    outletId:any
    params?:Record<string,any>
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ORGANIZATION_LIST", outletId, params],
      queryFn: () => getOutletOrganizationList(params,outletId),
      enabled,
      retry: false,
    });
  };

   export const useGetOutletAddressList = ({
    enabled,
    outletId,
    params
  }: {
    enabled: boolean;
    outletId:any
    params?:Record<string,any>
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ADDRESS_LIST", outletId, params],
      queryFn: () => getOutletAddressList(params,outletId),
      enabled,
      retry: false,
    });
  };


  export const useAddOutletAddress =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addOutletAddress(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ADDRESS_LIST"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet:", error.message)
    }
      
   })
} 

 export const useUpdateOutletAddress =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>updateOutletAddress(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ADDRESS_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ADDRESS_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet:", error.message)
    }
      
   })
} 

   export const useGetOutletOrgDataById = ({
    enabled,
    params
  }: {
    enabled: boolean;
    params?:Record<string,any>
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ORG_BY_ID", params],
      queryFn: () => getOutletOrganizationDataById(params),
      enabled,
      retry: false,
    });
  };

   export const useGetOutletVisitFrequency = ({
    enabled,
    
  }: {
    enabled: boolean;
   
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_VISIT_FREQUENCY"],
      queryFn: () => getOutletVisitFrequency(),
      enabled,
      retry: false,
    });
  };

  export const useAddOutletOrgData =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addOutletOrgData(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Data:", error.message)
    }
      
   })
} 

export const useUpdateOutletOrgData =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>updateOutletOrgData(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_LIST"] });
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_BY_ID"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Data:", error.message)
    }
      
   })
} 


export const useGetOutletMappingList = ({
    enabled,
    outletId,
    params
  }: {
    enabled: boolean;
    outletId:any
    params?:Record<string,any>
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_MAPPING_LIST", outletId, params],
      queryFn: () => getOutletMappingList(params,outletId),
      enabled,
      retry: false,
    });
  };

    export const useOutletMappingById = ({
    enabled,
    params,
  }: {
    enabled: boolean;
    params:Record<string,any>;

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_MAPPING_BY_ID",params],
      queryFn: () => getOutletMappingById(params),
      enabled,
      retry: false,
    });
  };

  export const useOutletCategoryTypes = ({
   enabled
  }: {
   
enabled:boolean
  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_CATEGORY_TYPE"],
      queryFn: () => getOutletCategoryTypes(),
      enabled,
      retry: false,
    });
  };

     export const useOutletParent = ({
    enabled,
    params,
  }: {
    enabled: boolean;
    params:Record<string,any>;

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_PARENT",params],
      queryFn: () => getOutletParent(params),
      enabled,
      retry: false,
    });
  };


  export const useOutletQulificationList = ({
    enabled,
    
  }: {
    enabled: boolean;

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_QUALIFICATION_LIST"],
      queryFn: () => getOutletQualificationList(),
      enabled,
      retry: false,
    });
  };



export const useUpdateOutletMapping =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    // Accept a single object argument with reqBody and param as properties
    mutationFn:({ reqBody, param }: { reqBody: any; param: any }) => updateOutletMapping(reqBody, param),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_MAPPING_LIST"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Update Outlet Mapping:", error.message)
    }
      
   })
} 

 export const useAddOutletMapping =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:any)=>addOutletMapping(reqBody),
    
    
    onSuccess:(e)=>{
        showToast.success(e.message);
          queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_MAPPING_LIST"] });
    },
    onError:(error:any)=>{
    console.error("Failed to Add Outlet Mapping:", error.message)
    }
      
   })
}



export const useOutletDCRSummary = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_DCR_SUMMARY",id,params],
      queryFn: () => getOutletDCRSummary(id,params),
      enabled,
      retry: false,
    });
  };

  export const useOutletSgpiOutSummary = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_SGPI_OUT_SUMMARY",id,params],
      queryFn: () => getOutletSgpiOutSummary(id,params),
      enabled,
      retry: false,
    });
  };

  export const useOutletRcpaSummary = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_RCPA_SUMMARY",id,params],
      queryFn: () => getOutletRCPASummary(id,params),
      enabled,
      retry: false,
    });
  };


    export const useOutletInventory = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_INVENTORY",id,params],
      queryFn: () => getOutletStockList(id,params),
      enabled,
      retry: false,
    });
  };



 export const useUpdateOutletInventory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) => updateOutletStock(id, body),

    onSuccess: (e) => {
      showToast.success(e.message);
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_INVENTORY"] });
    },

    onError: (error: any) => {
      console.error("Failed to update outlet inventory:", error.message);
      showToast.warning(error.message);
    },
  });
};

 export const useOutletOrgNoteList = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ORG_NOTE_LIST",id,params],
      queryFn: () => getOutletOrgNotesList(id,params),
      enabled,
      retry: false,
    });
  };

   export const useOutletOrgNoteByID = ({
    enabled,
    params,
    outletOrgDataId
  }: {
    enabled: boolean;
    outletOrgDataId:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_OUTLET_ORG_NOTE_BY_ID",outletOrgDataId,params],
      queryFn: () => getOutletOrgNoteById(outletOrgDataId,params),
      enabled,
      retry: false,
    });
  };

   export const useUpdateOutletOrgNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) => updateOutletOrgNote(id, body),

    onSuccess: (e) => {
      showToast.success(e.message);
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_NOTE_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_NOTE_BY_ID"] });
    },

    onError: (error: any) => {
      console.error("Failed to update outlet Note:", error.message);
      showToast.warning(error.message);
    },
  });
};


  export const useAddOutletOrgNote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) => addOutletOrgNote(id, body),

    onSuccess: () => {
      showToast.success("Outlet Note add Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_ORG_NOTE_LIST"] });
    },

    onError: (error: any) => {
      console.error("Failed to add outlet Note:", error.message);
      showToast.error(error.message);
    },
  });
};

 export const useBeatOutletList = ({
    enabled,
    params,
    id
  }: {
    enabled: boolean;
    id:number,
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_BEAT_OUTLET_LIST",id,params],
      queryFn: () => getBeatOutletList(id,params),
      enabled,
      retry: false,
    });
  };


   export const useBeatOutletStatus = ({
    enabled,
  }: {
    enabled: boolean;

  }) => {
    return useQuery({
      queryKey: ["GET_BEAT_OUTLET_STATUS"],
      queryFn: () => getBeatOutletStatus(),
      enabled,
      retry: false,
    });
  };

     export const useBeatOutletByID = ({
    enabled,
    params,
    
  }: {
    enabled: boolean;
    params?:Record<string,any>

  }) => {
    return useQuery({
      queryKey: ["GET_BEAT_OUTLET_BY_ID",params],
      queryFn: () => getBeatOutletById(params),
      enabled,
      retry: false,
    });
  };


     export const useUpdateBeatOutlet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: {  body: any }) => updateBeatOutlet( body),

    onSuccess: (e) => {
      showToast.success(e.message);
      queryClient.invalidateQueries({ queryKey: ["GET_BEAT_OUTLET_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_BEAT_OUTLET_BY_ID"] });
    },

    onError: (error: any) => {
      console.error("Failed to update Beat outlet :", error.message);
      showToast.error(error.message);
    },
  });
};


  export const useAddBeatOutlet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body: any }) => addBeatOutlet( body),

    onSuccess: (e) => {
      showToast.success(e.message);
      queryClient.invalidateQueries({ queryKey: ["GET_BEAT_OUTLET_LIST"] });
    },

    onError: (error: any) => {
      console.error("Failed to add Beat outlet :", error.message);
      showToast.error(error.message);
    },
  });
};